import * as Yup from 'yup';
import {object, setLocale, string} from 'yup';

Yup.addMethod(Yup.string, 'integer', function () {
  return this.matches(/^-?[0-9]+(?:\.[0-9]+)?$/, 'Digits only');
})
Yup.addMethod(Yup.string, 'positiveNumber', function () {
  return this.test('positiveNumber1', 'Only positive num', (value) => { return Number(value) >= 0 });
})
Yup.addMethod(Yup.string, 'isUUID', function () {
  return this.test('isUUID', 'Must be UUID', (value) => { return /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/i.test(value) });
})

Yup.addMethod(Yup.string, 'isValidPwdLength', function () {
  return this.test({
    name: 'isValidPwdLength',
    exclusive: false,
    test(v) {
      const MIN_LENGTH = 8;
      const MAX_LENGTH = 100;

      if (v.length < MIN_LENGTH) return this.createError({message: `Min password length is ${MIN_LENGTH} symbols`});
      if (v.length > MAX_LENGTH) return this.createError({message: `Max password length is ${MAX_LENGTH} symbols`});

      return true;
    },
  });
})

Yup.addMethod(Yup.string, 'withoutCyrillicSymbols', function (msg) {
  return this.test({
    name: 'withoutCyrillicSymbols',
    exclusive: false,
    message: msg || 'Please delete cyrillic symbols',
    test(v) {
      return !/^[А-я]+$/.test(v);
    },
  });
})

Yup.addMethod(Yup.string, 'isValidOldPwd', function (msg) {
  return this.test({
    name: 'isValidOldPwd',
    exclusive: false,
    message: msg || 'Password may contain only numbers, english letters and special symbols',
    test(v) {
      return /^[A-Za-z0-9_\-!&`2#$%@^*}{\[\]()=+?/\\'"<>.,|:;~]+$/.test(v);
    },
  });
})

Yup.addMethod(Yup.string, 'isValidNewPwd', function () {
  return this.test({
    name: 'isValidNewPwd',
    exclusive: false,
    test(v) {
      if (!/[A-Z]/.test(v)) return this.createError({message: 'Password must contain at least one uppercase symbol'});
      if (!/[a-z]/.test(v)) return this.createError({message: 'Password must contain at least one lowercase symbol'});
      if (!/[0-9]/.test(v)) return this.createError({message: 'Password must contain at least one number'});

      return true;
    },
  });
});

Yup.addMethod(Yup.string, 'isValidEmail', function (msg) {
  return this.test({
    name: 'isValidEmail',
    exclusive: false,
    message: msg || `Invalid email format`,
    test(v) {
      return !!(
        v && v.length < 255
        && /^[_a-z0-9-]+(\.[_a-z0-9-]+)*(\+[a-z0-9]+)?@[a-z0-9-]+(\.[a-z0-9-]{2,})+$/i
          .exec(v)
      );
    },
  });
})

setLocale({
  mixed: {
    required: 'Required Field'
  },
  string: {
    email: 'Must be an email'
  }
});

export const fileSchema = object({
  id: string().required(),
  file_name: string(),
  lifeflow_status: string().oneOf(['completed'])
});
